import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../config/config";
import Video from "../../../assets/img/welcome.mp4";
import Footer from "../../footer";
import Header from "../../Header/index";
import "./style.css";

const NewsShow = () => {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [newsItems, setNewsItems] = useState([]);
  const { t, i18n } = useTranslation();

  const languageMap = {
    tj: 1,
    ru: 2,
    en: 3,
  };
  const getLanguageCode = (lang) => languageMap[lang] || 2;

  const fetchNewsItems = (langCode) => {
    axios
      .get(`${API_BASE_URL}/api/events?lang=${langCode}&eventType=1`, {
        headers: {
          accept: "text/plain",
          "api-version": "1.0",
        },
      })
      .then((response) => {
        const filteredNews = response.data.enttities
          .filter((item) => item.type === 1 && item.id !== Number(id))
          .slice(0, 2);
        setNewsItems(filteredNews);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const fetchNewsItem = (langCode) => {
    axios
      .get(`${API_BASE_URL}/api/events/${id}?lang=${langCode}`, {
        headers: {
          accept: "text/plain",
          "api-version": "1.0",
        },
      })
      .then((response) => {
        setNewsItem(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    fetchNewsItems(langCode);
    fetchNewsItem(langCode);
  }, [id, i18n.language]);

  if (!newsItem) {
    return <div>{t("Loading...")}</div>;
  }

  return (
    <>
      <div className="position-relative white-text" style={{ height: "200px" }}>
        <video
          autoPlay
          loop
          muted
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        >
          <source src={Video} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 5000,
          }}
        >
          <Header />
        </div>
      </div>

      <div className="container mt-5" style={{ marginBottom: 60 }}>
        <div className="row">
          <div className="col-lg-8 col-md-12 mb-4">
            <div
              className="news-show p-4"
              style={{
                backgroundColor: "white",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              }}
            >
              <h1
                className="titleNewsShowByid"
                style={{
                  fontSize: "2rem",
                  fontWeight: "700",
                  marginBottom: "1rem",
                  lineHeight: "1.3",
                  color: "#1f2937",
                }}
                dangerouslySetInnerHTML={{ __html: newsItem.title }}
              />
              <p
                className="DateNewsById"
                style={{
                  color: "#6b7280",
                  fontSize: "0.9rem",
                  marginBottom: "1.5rem",
                }}
              >
                {new Date(newsItem.createdDate).toLocaleDateString()}
              </p>
              <p
                className="DescriptionNewsById"
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "500",
                  color: "#374151",
                  marginBottom: "1.5rem",
                  lineHeight: "1.6",
                }}
                dangerouslySetInnerHTML={{ __html: newsItem.shortDesc }}
              />
              <div
                style={{
                  width: "100%",
                  height: "450px",
                  overflow: "hidden",
                  borderRadius: "6px",
                  marginBottom: "1.5rem",
                }}
              >
                <img
                  className="imgNewsShowByid"
                  src={newsItem.image}
                  alt="News"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
              <p
                className="DescriptionNewsById card-text-long"
                style={{
                  fontSize: "1rem",
                  lineHeight: "1.7",
                  color: "#4b5563",
                  textAlign: "justify",
                }}
                dangerouslySetInnerHTML={{ __html: newsItem.longDesc }}
              />
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <h3
              className="titleNewsShow text-center fw-bold"
              style={{
                marginBottom: "1.5rem",
                color: "#1f2937",
              }}
            >
              {t("Latest news")}
            </h3>
            {newsItems.map((item, index) => (
              <div key={index} className="mb-4">
                <div
                  className="card cardBlocNews"
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    maxWidth: "100%",
                    transition: "box-shadow 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 4px 6px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow =
                      "0 1px 3px rgba(0,0,0,0.1)";
                  }}
                >
                  <div
                    className="position-relative"
                    style={{
                      width: "100%",
                      height: "200px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={
                        item.image ||
                        "https://www.imgacademy.com/sites/default/files/styles/scale_1700w/public/2022-07/img-homepage-meta_0.jpg?itok=LMirU0Ik"
                      }
                      className="card-img-top"
                      alt="News"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      className="date-label position-absolute"
                      style={{
                        backgroundColor: "rgba(0,0,0,0.75)",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "4px",
                        fontSize: "0.85rem",
                        top: "10px",
                        right: "10px",
                      }}
                    >
                      {new Date(item.createdDate).toLocaleDateString()}
                    </div>
                  </div>
                  <div className="card-body" style={{ padding: "1.25rem" }}>
                    <h5
                      className="card-title"
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: "600",
                        marginBottom: "0.75rem",
                        color: "#1f2937",
                        lineHeight: "1.4",
                      }}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    />
                    <p
                      style={{
                        color: "#6b7280",
                        fontSize: "0.9rem",
                        lineHeight: "1.5",
                        marginBottom: "1rem",
                      }}
                      className="card-text"
                      dangerouslySetInnerHTML={{ __html: item.shortDesc }}
                    />
                    <Link
                      to={`/news/show/${item.id}`}
                      className="btn ButtonM w-100"
                      style={{
                        padding: "0.5rem 1rem",
                        fontSize: "0.95rem",
                        borderRadius: "6px",
                      }}
                    >
                      {t("Read more")}
                    </Link>
                  </div>
                </div>
              </div>
            ))}

            <div className="text-end">
              <Link
                to={`/news`}
                className="LincNesw fw-bold"
                style={{
                  fontSize: "1rem",
                  textDecoration: "none",
                }}
              >
                {t("viewAll")} →
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewsShow;
